export const UPDATE_LOCALE = 'app/store/i18n/UPDATE_LOCALE'
